import { createSlice } from "@reduxjs/toolkit";

export const NOTIFICATION = "notification";

const notificationSlice = createSlice({
    name: NOTIFICATION,
    initialState: {
        isLoading: false,
        notificationList: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setNotificationList(state, action) {
            state.notificationList = action.payload;
        },
    },
});

export const { setIsLoading, setNotificationList } = notificationSlice.actions;
export default notificationSlice.reducer;